export default "__VITE_ASSET__SqTSAHkM__"